"use client";

import Image from "next/image";
import Link from "next/link";
import { useUser } from "@/hooks/user/useUser";
import { IconLogout } from "@tabler/icons-react";
import { accountMenuItems } from "../layout.type";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLogout } from "@/hooks/auth/useAuth";
import { FALLBACK_FEATURE_IMAGE } from "@/lib/utils";
import { Separator } from "@/components/ui/separator";
import { Typography } from "@/components/Typography";

export const AccountMenu = () => {
  const { mutateAsync: logout, isPending } = useLogout();
  const { data: user } = useUser();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          id="account-menu-trigger"
          type="button"
          aria-label="Open account menu"
          className="flex h-[32px] w-[32px] items-center justify-center overflow-hidden rounded-full"
        >
          <Image
            src={user?.avatar || FALLBACK_FEATURE_IMAGE}
            alt=""
            width={32}
            height={32}
            priority
            sizes="32px"
            className="h-full w-full"
          />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        id="account-menu-content"
        align="end"
        sideOffset={18}
        className="w-[250px] rounded-2xl border bg-white p-2 shadow-2xl"
      >
        <div className="flex flex-col gap-1">
          {accountMenuItems.map((item) => {
            const Icon = item.icon;

            return (
              <DropdownMenuItem
                key={item.label}
                asChild
                className="h-[48px] w-[234px] rounded-xl px-5 py-3 hover:cursor-pointer hover:bg-subtle"
              >
                <Link
                  href={item.href}
                  className="flex h-full w-full items-center gap-3 text-heading"
                >
                  <Icon
                    className="h-6 w-6 shrink-0 text-heading"
                    strokeWidth={1.8}
                  />
                  <Typography variant="subtitle1">
                    {item.label}
                  </Typography>
                </Link>
              </DropdownMenuItem>
            );
          })}

          <Separator className="my-1" />

          <DropdownMenuItem
            asChild
            className="h-[48px] w-[234px] rounded-xl px-5 py-3 hover:cursor-pointer hover:bg-subtle"
          >
            <button
              type="button"
              disabled={isPending}
              onClick={() => {
                void logout();
              }}
              className="flex h-full w-full items-center gap-3 text-heading"
            >
              <IconLogout />
              <Typography variant="subtitle1">
                Logout
              </Typography>
            </button>
          </DropdownMenuItem>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
